import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstDr3: [],
		dr3: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getDr3: state => state.dr3,
		getLstDr3: state => state.lstDr3,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
		getItemsPerPage: state => state.itemsPerPage,
		getSearch: state => state.search,
		getHasNext: state => state.hasNext,
	},
	mutations: {
		initForm(state) {
			state.insert = false
			state.update = false
			state.dr3 = null
		},
		setDr3(state, dr3) {
			state.dr3 = dr3
			if (dr3) state.update = true
		},
		setLstDr3(state, lstDr3) {
			state.lstDr3 = lstDr3
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setInsert(state, insert) {
			state.insert = insert
		},
		setSearch(state, search) {
			state.search = search
		},
		setParamsDataTable(state, payload) {
			state.lstDr3 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm({ commit, dispatch }) {
			commit("initForm")
			dispatch("dr4/initForm", null, { root: true })
		},
		async find({ commit, dispatch }, dr3lote) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/LaunchBatch/Find/${dr3lote}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					let { lstDr4, ...dr3 } = payload
					commit("setDr3", dr3)
					dispatch("dr4/setLstDr4", lstDr4, { root: true })
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		save({ dispatch, getters }) {
			if (getters.getUpdate) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ dispatch, commit, getters, rootGetters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			if (!getters.getDr3.dr3lote) {
				getters.getDr3.dr3lote = await dispatch("dictionary/getNextNumber", "dr3lote", { root: true })
			}
			let payload = await this._vm.$axios
				.post("/Financial/LaunchBatch/Insert", { ...getters.getDr3, lstDr4: rootGetters["dr4/getLstDr4NotEmpty"] })
				.then(response => {
					let responsePayload = Utils.ValidateAxiosResponse(response.data)
					let { lstDr4, ...dr3 } = responsePayload
					commit("setDr3", dr3)
					dispatch("dr4/setLstDr4", lstDr4, { root: true })
					return dr3
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch, commit, getters, rootGetters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.put("/Financial/LaunchBatch/Update", { ...getters.getDr3, lstDr4: rootGetters["dr4/getLstDr4NotEmpty"] })
				.then(response => {
					let responsePayload = Utils.ValidateAxiosResponse(response.data)
					let { lstDr4, ...dr3 } = responsePayload
					commit("setDr3", dr3)
					dispatch("dr4/setLstDr4", lstDr4, { root: true })
					return dr3
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.delete(`/Financial/LaunchBatch/Delete/${getters.getDr3.dr3lote}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/LaunchBatch/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstDr3", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		setSearch({ commit }, search) {
			commit("setSearch", search)
		},
		setInsert({ commit, dispatch }, insert) {
			commit("setInsert", insert)
			dispatch("dr4/initForm", null, { root: true })
		},
	},
}
